// @ts-nocheck

import SettingOutlined from '@ant-design/icons/SettingOutlined';
import AuditOutlined from '@ant-design/icons/AuditOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';
import CarryOutOutlined from '@ant-design/icons/CarryOutOutlined';
import MailOutlined from '@ant-design/icons/MailOutlined'

export default {
  SettingOutlined,
AuditOutlined,
UnorderedListOutlined,
CarryOutOutlined,
MailOutlined
}
    